<template>
  <b-icon icon="exclamation-circle-fill" variant="danger" />
</template>

<script>
export default {
  name: 'ExclamationMark',
}
</script>
